import { roundToTwoDecimal } from './helper';

export const calculate = (() => {
  return {
    sebi(sebi: number, buyValue: number, sellValue: number): number {
      return roundToTwoDecimal(((buyValue + sellValue) * sebi) / 10000000);
    },

    gst(gst: number, brokerage: number, exchangeTransactionCharges: number, sebi: number): number {
      return roundToTwoDecimal(((brokerage + exchangeTransactionCharges + sebi) * gst) / 100);
    },

    nseipft(nseipft: number, buyValue: number, sellValue: number): number {
      return roundToTwoDecimal(((buyValue + sellValue) * nseipft) / 10000000);
    },

    exchangeTransactionCharges(exchangePercentage: number, buyValue: number, sellValue: number): number {
      return roundToTwoDecimal((exchangePercentage * (sellValue + buyValue)) / 100);
    },

    stampDuty(stampDuty: number, buyValue: number): number {
      return roundToTwoDecimal((stampDuty * buyValue) / 100);
    },

    stt(stt: number, sellValue: number): number {
      return roundToTwoDecimal((stt * sellValue) / 100);
    },
  };
})();
